import Vue from 'vue';
// import trackers from '../../../api/savanna/trackers.api';
// import _ from 'lodash';

const mapNames = (a) => {
  const obj = {
    name: a.lcu_name,
    id: a.lcu_code
  };
  return obj;
};

const mapStatus = (a) => {
  const obj = {
    gcuCode: a.gcu_code,
    status: a.status,
    armErrors: a.armErrors,
    lcuCode: a.lcu_code,
    lcuName: a.lcu_name,
    lastCollection: a.timestamp,
    lastStatusCollection: a.lastStatusCollection
  };
  return obj;
};

const filterGCUs = (gcuCode) => {
  return (a) => {
    if (gcuCode) {
      return a.gcu_code === gcuCode;
    }
    return true;
  };
};

const state = {
  trackers: [],
  statusCodes: [],
  armatureStatusCodes: []
};

const decodeArmStatus = (status) => {
  const armErrors = [];
  if (status) {
    status.forEach((error) => {
      // 63 and 64 are values that are being used for information about restarts (they don't actually represent the arm status)
      // for the purpose of this application we're considering them 'Healthy'
      if (error < 31 || error === 255) {
        armErrors.push({
          name: state.armatureStatusCodes.find(a => a.code === error).short_name,
          code: error
        });
      } else if (error === 63 || error === 64) {
        armErrors.push({
          name: 'Healthy',
          code: error
        });
      } else {
        armErrors.push({
          name: 'Other Error',
          code: error
        });
      }
    });
  }
  return armErrors;
};

const decodeTrackerStatus = (status) => {
  const trackerStatus = {
    code: status,
    description: null
  };

  if (status) {
    trackerStatus.description = state.statusCodes.find(a => a.tracker_code === status).description;
  } else {
    trackerStatus.description = 'Unknown';
  }

  return trackerStatus;
};

const getters = {
  getTrackerNames: state => (gcu) => {
    if (state.trackers.length === 0) {
      return [];
    }
    return state.trackers.filter(filterGCUs(gcu)).map(mapNames);
  },
  getTrackerStatus: state => (gcu) => {
    if (state.trackers.length === 0) {
      return [];
    }
    return state.trackers.filter(filterGCUs(gcu)).map(mapStatus);
  }
};

const mutations = {
  setTrackers(state, trackerData) {
    // TODO: determine the best way to make this happen (Runs unusably slow with strict mode enabled in vuex)
    if (trackerData !== undefined && trackerData !== null && trackerData.length > 0) {
      trackerData.forEach((tracker) => {
        state.trackers.push(tracker);
      });
    }
  },
  setTrackerStatus(state, msg) {
    const trackerData = msg.body;
    const { gcu } = msg;
    if (trackerData.length > 0) {
      trackerData.forEach((tracker) => {
        const index = state.trackers.findIndex(a => a.gcu_code === gcu && a.lcu_code === tracker.lcu_code);
        if (index !== -1) {
          const trackerCopy = JSON.parse(JSON.stringify(state.trackers[index]));
          trackerCopy.status = decodeTrackerStatus(tracker.tracker_status);
          trackerCopy.armErrors = decodeArmStatus(tracker.armature_errors);
          trackerCopy.timestamp = msg.headers.timestamp.replace(new RegExp('\\c', 'g'), ':').replace(new RegExp("'", 'g'), '');
          trackerCopy.lastStatusCollection = tracker.last_collection;
          Vue.set(state.trackers, index, trackerCopy);
        }
      });
    }
  },
  setTrackerStatusCodes(state, codes) {
    state.statusCodes = codes;
  },
  setArmatureStatusCodes(state, codes) {
    state.armatureStatusCodes = codes;
  }
};

const actions = {
  async getTrackers({ commit }, options) {
    const { trackers } = await this.$api.get('/v1/trackers', options);
    commit('setTrackers', trackers);
  },
  async getTrackerStatusCodes({ commit }) {
    const { codes } = await this.$api.get('/v1/trackers/codes');
    commit('setTrackerStatusCodes', codes);
  },
  async getArmatureStatusCodes({ commit }) {
    const { codes } = await this.$api.get('/v1/trackers/armaturecodes');
    commit('setArmatureStatusCodes', codes);
  }
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
